import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import { prismicImage } from 'src/common/utils/prismic-image';
import './FullWidthImage.scss';

const FullWidthImage = props => (
  <section className="full-width-image" id={props.id}>
    <LazyLoad>
      <img src={prismicImage(props.image)} alt="" />
    </LazyLoad>
  </section>
);

FullWidthImage.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

export default FullWidthImage;



// WEBPACK FOOTER //
// ./src/client/js/view/components/FullWidthImage/FullWidthImage.js